<template>
  <div class="intro-page row-1 m-top-10 m-bot-9" :class="customStyle">
    <div v-if="item.sectionTitle">
      <div
        class="title-big4 is-medium-bold m-bot-10 title"
        v-html="item.sectionTitle"
      />
    </div>
    <div v-if="item.text">
      <div class="title-base text" v-html="item.text" />
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  item: {
    type: Object,
    default: () => ({}),
  },
  customStyle: {
    type: String,
    default: '',
  },
})
</script>

<script>
export default {
  name: 'TitleText',
}
</script>

<style lang="scss">
@import './style.scss';
</style>
